import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { withBaseProps } from '@topconagriculture/react-components';
import { toCssValue } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    contentWrapper: {
        display: 'flex',
        padding: toCssValue([10, 20]),
    },
    noPadding: {
        padding: 0,
    },
});
const PanelContent = (props) => {
    const { classes, children, noPadding } = props;
    const contentWrapperClasses = classNames({
        [classes.contentWrapper]: true,
        [classes.noPadding]: noPadding,
    });
    return React.createElement("div", { className: contentWrapperClasses }, children);
};
export default compose(withBaseProps({ styles }))(PanelContent);
//# sourceMappingURL=PanelContent.js.map